export const readPendingTrailDeletes = () => {
  try {
    const raw = localStorage.getItem("trailsPendingDelete") || "{}";
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const addPendingTrailDelete = (filename) => {
  if (!filename) return;
  const next = readPendingTrailDeletes();
  next[filename] = Date.now();
  try {
    localStorage.setItem("trailsPendingDelete", JSON.stringify(next));
  } catch {}
};

export const removePendingTrailDelete = (filename) => {
  if (!filename) return;
  const next = readPendingTrailDeletes();
  if (!next[filename]) return;
  delete next[filename];
  try {
    localStorage.setItem("trailsPendingDelete", JSON.stringify(next));
  } catch {}
};
